import React from 'react'
import LoadingPage from '../global/LoadingPage';
import { useBasicData } from '../../hooks/useBasicData';
import { useState } from "react";
import { NavLink, Link as RouterLink } from "react-router-dom";
import { IconButton, AppBar, Box, Toolbar, styled, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import i18next from "i18next";
import NavDrawer from "./NavDrawer";
import TransLang from "./TransLang"
import { useTheme } from '@mui/material/styles';
import { Pages } from "../../constants";
import logo from './../../assets/Logo/logo.png'

const NavBar = () => {
    const theme = useTheme();
    let lng = i18next.language
    const [drawer, setDrawer] = useState(false);
    const StyledLink = styled(NavLink)(({ theme, isActive }) => ({
        textDecoration: "none",
        fontSize: 16,
        textTransform: 'uppercase',
        color: isActive ? theme.palette.nav.hover : theme.palette.nav.link,
        transition: '0.5s',
        fontWeight: 500,
        '&:hover': {
            color: theme.palette.nav.hover,
            textDecoration: 'underline',
        },
    }));
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
    const { isLoading, basicData } = useBasicData()
    if (isLoading) return <LoadingPage />


    return (
        <>
            <AppBar position="static" elevation={0} sx={{
                backgroundColor: theme.palette.nav.main,
                boxShadow: "0px 4px 4px rgba(11, 7, 7, 0.25)",
                position: 'sticky',
                top: 0,
                zIndex: 999
            }}>
                <Toolbar disableGutters>
                    <Container maxWidth={'90%'} sx={{ width: { md: '90%', xs: '100%' }, m: 'auto' }}>
                        <Box
                            sx={{
                                flexGrow: 1,
                                display: { md: "flex", xs: "none" },
                                alignItems: "center",
                                justifyContent: 'space-between',
                            }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <RouterLink
                                    to="/"
                                    style={{ textDecoration: "none", lineHeight: 1 }}>
                                    <img src={logo || basicData?.data?.headerLogo} alt="logo" className="nav-logo" />
                                </RouterLink>
                            </Box>
                            <Box sx={{
                                flexGrow: 1,
                                display: { md: "flex", xs: "none" },
                                alignItems: "center",
                                justifyContent: 'center',
                                gap: '2%'
                            }}>
                                {Pages?.map((page, i) => (
                                    <StyledLink
                                        key={i}
                                        to={page.path}
                                        className={'link text_bold'}
                                        onClick={() => scrollToTop()}
                                        style={({ isActive }) => ({
                                            color: isActive ? theme.palette.nav.hover : theme.palette.nav.link,
                                        })}
                                    >
                                        {lng === 'ar' ? page.name : page.name_en}
                                    </StyledLink>
                                ))}
                            </Box>
                            <TransLang />
                        </Box>
                        <Box
                            sx={{
                                flexGrow: 0,
                                display: { md: "none", xs: "flex" },
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: 'center',
                                gap: { md: '65px', xs: 1 },
                            }}>
                            <RouterLink
                                to="/"
                                style={{
                                    textDecoration: "none",
                                    lineHeight: 1
                                }}>
                                <img src={logo || basicData?.data?.headerLogo} alt="logo" className="nav-logo" ></img>
                            </RouterLink>
                            <IconButton onClick={() => setDrawer(true)}>
                                <MenuIcon sx={{ fontSize: '2rem', color: theme.palette.secondary.main }} />
                            </IconButton>
                        </Box>
                    </Container>
                </Toolbar>
            </AppBar>
            <NavDrawer drawer={drawer} setDrawer={setDrawer} data={basicData?.data} />
        </>
    )
}

export default NavBar